import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "Consumer" }
const _hoisted_2 = { style: {"height":"60px","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"height":"60px","line-height":"60px","text-align":"center","margin-left":"14px"} }
const _hoisted_4 = { class: "modal" }
const _hoisted_5 = { key: 0 }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { accessTableConfig } from './config/access.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { ref, watch } from 'vue'
import { toDay, secondToString } from '@/utils/date-format'
import {
  getPageListData,
  editPageData,
  getListData
} from '@/service/main/system'

import { useRoute } from 'vue-router'
import LfTable from '@/components/LfTable.vue'

import { useStore } from '@/store'
import { ElMessage } from 'element-plus'
import { initEmptyParam } from '@/hooks/useInitParam'
import localCache from '@/utils/cache'


export default /*#__PURE__*/_defineComponent({
  __name: 'Consumer',
  setup(__props) {

initEmptyParam()
const pageInfo = ref({ pageNo: 1, pageSize: 10 })
const store = useStore()
const userInfo = store.state.login.userInfo

const dialogVisible = ref(false)

const route = useRoute()
let query = {}
if (route.query['deptId']) {
  const depts = store.state.login.depts
  for (const dept of depts) {
    if (dept.id == route.query['deptId']) {
      const empIds = []
      for (const emp of dept.emps) {
        empIds.push(emp.id)
      }
      query = { empIds }
    }
  }
  query = { ...query, createdTime: route.query.createdTime }
} else {
  query = { ...route.query }
}

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return { title: item.realName, value: item.id }
  })
  const userItem = searchFormConfig.formItems.find(
    (item) => item.field === 'empIds'
  )
  const modalUserItem = modalConfig.formItems.find(
    (item) => item.field === 'dealEmpId'
  )
  userItem!.options = userOptions
  modalUserItem!.options = userOptions
}
getEmp()

const queryParam = {
  empIds: userInfo.id,
  createdTime: [toDay(), toDay()],
  ...query
}
store.commit('system/changeQueyryInfo', queryParam)

let queryInfo = {}

const handleAccessClick = (item: any) => {
  dialogVisible.value = true
  getPageData(item.id)
}
//获取数据
const dataList = ref<any[]>([])
const dataCount = ref<number>(0)

const getPageData = async (id: string) => {
  queryInfo = {
    consumerId: id,
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize
  }

  const data = await getPageListData('/main/consumer/consumerAccess', queryInfo)
  dataList.value = data.list
  dataCount.value = Number(data.total)
}

//监听分页事件
watch(pageInfo, () => getPageData(queryInfo.consumerId))

const modalTitle = ref('新增')

const newCb = () => {
  modalTitle.value = '新增客户'
}

const editCb = () => {
  modalTitle.value = '编辑成交信息'
}
const resetCb = () => {
  return queryParam
}
let consumerIds: Array<number> = []
// 多选框选择事件
const handleSlectionChange = (value: any[]) => {
  consumerIds = []
  for (const row of value) {
    consumerIds.push(row.id)
  }
}

//批量编辑点击事件
const handleBatchData = () => {
  if (consumerIds.length == 0) {
    ElMessage({
      message: '请至少选择一项',
      type: 'warning'
    })
    return
  }
  modalTitle.value = '批量编辑成交信息'
  defaultInfo.value = {}
  pageModalRef.value.dialogVisible = true
  pageModalRef.value.isBatch = true
}

const handleUpdateBatchData = async (formData: any) => {
  try {
    await editPageData('/main/consumer/batch/update', {
      ...formData,
      consumerIds: consumerIds
    })
    store.dispatch('system/getPageListAction', {
      pageName: 'consumer',
      queryInfo: store.state.system.queryInfo
    })
    pageModalRef.value.dialogVisible = false
  } finally {
    pageModalRef.value.confirmLoading = false
  }
}

const tagStyle = (typeName: string) => {
  let color = ''
  if (typeName == '同行') {
    color = 'red'
  }

  if (typeName == '全款') {
    color = 'purple'
  }
  return { color }
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "consumer",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onBatchBtnClick: handleBatchData,
      onSelectionChange: handleSlectionChange
    }, {
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 60,
            src: scope.row.headImgUrl
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.nickName), 1)
        ])
      ]),
      typeName: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle(tagStyle(scope.row.typeName))
        }, _toDisplayString(scope.row.typeName), 5)
      ]),
      access: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: ($event: any) => (handleAccessClick(scope.row))
        }, {
          default: _withCtx(() => [
            _createTextVNode("查看记录")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      validOtherInfo: () => true,
      pageName: "consumer",
      onUpdateBatchData: handleUpdateBatchData
    }, null, 8, ["defaultInfo", "modalConfig", "title"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_dialog, {
        title: "访问记录",
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
        width: "50%",
        center: "",
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [
          _createVNode(LfTable, _mergeProps({
            listData: dataList.value,
            listCount: dataCount.value
          }, _unref(accessTableConfig), {
            page: pageInfo.value,
            "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((pageInfo).value = $event))
          }), {
            duration: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(scope.row.duration)), 1)
            ]),
            content: _withCtx((scope) => [
              (!scope.row.url)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(scope.row.content), 1))
                : (_openBlock(), _createBlock(_component_el_link, {
                    key: 1,
                    href: scope.row.url,
                    type: "primary",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.content), 1)
                    ]),
                    _: 2
                  }, 1032, ["href"]))
            ]),
            _: 1
          }, 16, ["listData", "listCount", "page"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})